var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('icon',{attrs:{"name":"info-circle","color":"orange","width":"12","height":"12"}}),_c('span',{class:_vm.color},[(_vm.showTitle)?_c('b',[_vm._v("Tip")]):_vm._e(),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }